/**
 * UI / speak languages with lemma gloss rows in the lexicon DB and API.
 * German course UI (`de`, `ch`) keeps English gloss columns.
 */
export const LEXICON_GLOSS_SPEAK_LANGS = Object.freeze([
  "en",
  "tr",
  "ar",
  "uk",
  "vi",
  "es",
  "fr",
  "pl",
  "ru",
  "sl",
  "el",
]);

/** @type {ReadonlySet<string>} */
export const LEXICON_GLOSS_SPEAK_LANG_SET = new Set(LEXICON_GLOSS_SPEAK_LANGS);

/**
 * @param {string} [uiLang]
 * @returns {string}
 */
export function normalizeUiLangBase(uiLang) {
  return String(uiLang || "")
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
}

/**
 * Gloss column language for vocabulary list + lexicon API (`?speakLang=`).
 * @param {string} [uiLang]
 * @returns {string}
 */
export function lexiconGlossSpeakLangForUi(uiLang) {
  const base = normalizeUiLangBase(uiLang);
  if (base === "de" || base === "ch") return "en";
  if (LEXICON_GLOSS_SPEAK_LANG_SET.has(base)) return base;
  return "en";
}

/**
 * @param {string} [raw]
 * @returns {string}
 */
export function normalizeLexiconGlossSpeakLang(raw) {
  const base = normalizeUiLangBase(raw);
  if (LEXICON_GLOSS_SPEAK_LANG_SET.has(base)) return base;
  return "en";
}
